import React from "react";
import { useTranslation } from "react-i18next";

import { readState } from "@/__main__/app-state.mjs";
import { GAME_BOX_ICONS,GAME_SHORT_NAMES } from "@/app/constants.mjs";
import ArticleList from "@/marketing/ArticleList.jsx";
import { Section } from "@/marketing/ContentfulArticles.style.jsx";
import type { ContentfulFeatures } from "@/marketing/HomeGamePage.js";
import { CONTENTFUL_TAGS } from "@/shared/contentful-constants.mjs";
import { useGameSymbol } from "@/util/game-route.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

export default function ContentfulArticles({
  title,
  description,
  linkConstructor,
  cta,
  tags = [],
}: ContentfulFeatures) {
  const gameSymbol = useGameSymbol();
  const { t } = useTranslation();
  const {
    contentful: { related },
  } = useSnapshot(readState);

  const Icon = GAME_BOX_ICONS[gameSymbol];
  const shortName = GAME_SHORT_NAMES[gameSymbol];
  const articles = related
    .filter((article) => {
      const matchesGame = article.tags.includes(CONTENTFUL_TAGS[shortName]);
      const matchesTags = tags.every((tag) => article.tags.includes(tag));
      return matchesGame && matchesTags;
    })
    .sort((a, b) => b.createdAt - a.createdAt)
    .slice(0, 3)
    .map((i) => ({
      id: i.id,
      coverImageUrl: i.imageUrl,
      title: i.title,
      excerpt: i.excerpt,
      createdAt: i.createdAt,
      redirect: i.redirect,
      link: linkConstructor(i),
    }));

  return (
    <Section>
      {(!!title || !!description) && (
        <header>
          <div className="header-left">
            {!!title && (
              <h2 className="section-title type-page-header">{t(...title)}</h2>
            )}
            {!!description && (
              <p className="section-subtitle type-subtitle--bold">
                {t(...description)}
              </p>
            )}
          </div>
          {cta ? (
            <a href={cta.href} className="view-more type-subtitle--semi">
              {t(...cta.title)}
            </a>
          ) : null}
        </header>
      )}
      <ArticleList articles={articles} Icon={Icon} />
    </Section>
  );
}
